export default "__VITE_ASSET__7c7c772a__"